module.exports = __webpack_public_path__ + "static/media/location-maps-letter-d-arrow-serr2.c2d4ba19.png";